<div
  class="app-shell"
  data-qa="app-shell"
  >
  <!-- common location for all notification toasts via notificationsService --->
  <app-notifications key="app-notification"></app-notifications>

  <!-- shown when this tab is running a build that is no longer deployed -->
  <app-toast
    data-qa="stale-build-toast"
    [key]="staleBuildToastKey"
    actionButtonText="Refresh"
    (toastClicked)="reloadToLatestVersion()"
  ></app-toast>

  @if (showSpinner()) {
    <div
      aria-atomic="true"
      aria-live="assertive"
      class="bx--loading"
      data-qa="loading-spinner"
      [class.is-loading]="loading()"
      data-qa="loading-indicator"
      >
      <label
        id="loading-id-1"
        class="bx--visually-hidden"
        >Active loading indicator</label
        ><svg
        class="bx--loading__svg"
        viewBox="0 0 100 100"
        >
        <title>Active loading indicator</title>
        <circle
          class="bx--loading__stroke"
          cx="50%"
          cy="50%"
          r="40"
        ></circle>
      </svg>
    </div>
  }
  <router-outlet></router-outlet>
</div>
